import { createSlice } from 'utils/@reduxjs/toolkit';
import { StepState } from './types';
import { reducers } from './reducers';

export const initialState: StepState = {
  currentStep: 1,
};

const slice = createSlice({
  name: 'step',
  initialState,
  reducers,
});

export const { actions: stepActions } = slice;
export const { reducer: stepReducer } = slice;
